function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React, { useCallback } from 'react';
import { useState } from 'react';
import { useConfigAtomValues, useStateAtomValues, useStateAtom, useDataAtomValues } from '../../state';
import ShellModal from '../ShellModal';
import { usePayChannelId, useReturnUrl } from '../../hooks';
import { useEventAtom, EEvent } from '../../events';
import { CURRENCY_SGD } from '../../constants/currency';
var PayNowModal = function PayNowModal(props) {
  var _useConfigAtomValues = useConfigAtomValues(),
    billId = _useConfigAtomValues.billId,
    bizType = _useConfigAtomValues.bizType,
    subBizType = _useConfigAtomValues.subBizType,
    merchantNo = _useConfigAtomValues.merchantNo,
    wechatProps = _useConfigAtomValues.wechatProps,
    onCancelPay = _useConfigAtomValues.onCancelPay,
    countryCode = _useConfigAtomValues.countryCode,
    returnUrl = _useConfigAtomValues.returnUrl,
    setReturnUrlAsync = _useConfigAtomValues.setReturnUrlAsync,
    onSuccess = _useConfigAtomValues.onSuccess,
    env = _useConfigAtomValues.env,
    language = _useConfigAtomValues.language,
    appId = _useConfigAtomValues.appId,
    phone = _useConfigAtomValues.phone,
    email = _useConfigAtomValues.email;
  var _useDataAtomValues = useDataAtomValues(),
    productInfo = _useDataAtomValues.productInfo;
  var onPayCancel = props.onPayCancel,
    onPayFail = props.onPayFail,
    onPaySuccess = props.onPaySuccess;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    billIdInRealTime = _useState2[0],
    setBillIdInRealTime = _useState2[1];
  var _useStateAtomValues = useStateAtomValues(),
    payMethod = _useStateAtomValues.payMethod;
  var _useStateAtom = useStateAtom(),
    _useStateAtom2 = _slicedToArray(_useStateAtom, 2),
    setStateAtom = _useStateAtom2[1];
  var _usePayChannelId = usePayChannelId(),
    channelId = _usePayChannelId.channelId;
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    visible = _useState4[0],
    setVisible = _useState4[1];
  var handleReturnUrl = useReturnUrl();
  var onAfterClose = function onAfterClose() {
    var _wechatProps$onAfterC;
    /**
     * FIXME: PayNow 支付的交互方式，跟微信支付相同（弹窗展示二维码、关闭/取消弹窗是二次取消等交互），所以复用 WeChatProps 入参。
     * 后续调整为更通用的参数配置
     */
    wechatProps === null || wechatProps === void 0 ? void 0 : (_wechatProps$onAfterC = wechatProps.onAfterClose) === null || _wechatProps$onAfterC === void 0 ? void 0 : _wechatProps$onAfterC.call(wechatProps, billId);
  };

  // 关闭支付弹窗
  var closeModal = function closeModal() {
    setVisible(false);
  };
  var _useEventAtom = useEventAtom(),
    event$ = _useEventAtom.event$;

  // 事件监听
  event$ === null || event$ === void 0 ? void 0 : event$.useSubscription(function (subscription) {
    var type = subscription.type,
      payload = subscription.payload;
    // 启动了 PayNow 支付, 弹出 ShellModal
    if (type === EEvent.ON_PAY_WITH_PAYNOW) {
      setVisible(true);
      // 接收「在还没账单 id 的时候，通过接口创建的 billId 」
      setBillIdInRealTime(payload.billId);
    }
  });
  var handlePayFail = useCallback(function (payload) {
    setStateAtom(function (draft) {
      draft.payLoading = false;
    });
    onPayFail(payload);
  }, [onPayFail, setStateAtom]);
  var closingConfirmed = useCallback(function () {
    // FIXME: 复用了微信支付的入参
    if (wechatProps.closingConfirmed) {
      return wechatProps.closingConfirmed(productInfo);
    } else {
      return false;
    }
  }, [productInfo, wechatProps]);
  var handleRedirect = useCallback(function () {
    var handledReturnUrl = handleReturnUrl(billIdInRealTime);
    window.location.href = handledReturnUrl;
  }, [billIdInRealTime, handleReturnUrl]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, visible && /*#__PURE__*/React.createElement(ShellModal, {
    isNeedConfirmBeforeClosing: closingConfirmed,
    billId: billId,
    onPayCancel: onPayCancel,
    appId: appId,
    bizType: bizType,
    subBizType: subBizType,
    merchantNo: merchantNo,
    onAfterClose: onAfterClose
    // NOTE：onPaySuccess 作用包括了 onSuccess 的功能以及 状态重置 reset。
    ,
    onPaySuccess: onPaySuccess,
    closeModal: closeModal,
    returnUrl: returnUrl
    /** NOTE: 由于业务需求，PayNow 支付目前使用 SGD（新加坡元）作为交易币种  */,
    priceCurrencyCode: CURRENCY_SGD,
    payChannel: channelId,
    payMethod: payMethod,
    countryCode: countryCode,
    billIdInRealTime: billIdInRealTime,
    invokeCancelApiOnClose: onCancelPay === null || onCancelPay === void 0 ? void 0 : onCancelPay.invokeCancelApiOnClose,
    setReturnUrlAsync: setReturnUrlAsync,
    onPayFail: handlePayFail,
    onSuccess: onSuccess,
    env: env,
    language: language,
    onDirect: handleRedirect,
    phone: phone,
    email: email
  }));
};
export default PayNowModal;